// guide forms
const initGuideForms = () => {
  // open single-guide form
  const guideFormCTAButtons = document.querySelectorAll('.guide-form__cta .btn');
  guideFormCTAButtons.forEach((btn) => {
    const container = btn.closest('.guide-form');
    const btnWrapper = container.querySelector('.guide-form__cta');
    const formWrapper = container.querySelector('.guide-form__form-wrapper');
    const emailInput = formWrapper.querySelector('input[type="email"]');

    btn.addEventListener('click', (e) => {
      e.preventDefault();

      btnWrapper.style.display = 'none';
      formWrapper.style.display = 'flex';

      emailInput.focus();
    });
  });

  function getFilenameFromURL(urlPath) {
    const url = new URL(urlPath);
    const pathname = url.pathname;
    const parts = pathname.split('/');
    return parts.pop();
  }

  // validate recaptcha
  function validateCaptcha() {
    return new Promise((res, rej) => {
      if(typeof grecaptcha === 'undefined') {
        return res('');
      }

      grecaptcha.ready(() => {
        grecaptcha.execute('6LfT9PsqAAAAAFPziGcG8AmACKdlKV6q3515rsL2', { action: 'submit' }).then((token) => {
          return res(token);
        });
      });
    });
  }

  function validateEmail(email) {
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  }

  const guideForms = document.querySelectorAll('.guide-form');
  guideForms.forEach(guideForm => {
    const form = guideForm.querySelector('.guide-form__form');

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      // reset form states
      guideForm.classList.remove('loading');
      guideForm.classList.remove('success');
      guideForm.classList.remove('error');
      guideForm.querySelector('.guide-form__success').classList.remove('active');
      guideForm.querySelector('.guide-form__error').classList.remove('active');

      let token = await validateCaptcha();

      var headers = new Headers();
      headers.append('Content-Type', 'application/json');
      const email = form.querySelector('input[type="email"]').value;
      const campaign = form.querySelector('input[name="campaign"]').value;
      const url = `https://us-central1-arnolds-pump-club.cloudfunctions.net/newsletter?action=createSubscription`;

      const cookies = document.cookie
      const fbc = cookies.split("; ").find(row => row.startsWith("_fbc="))?.split("=")[1]
      const fbp = cookies.split("; ").find(row => row.startsWith("_fbp="))?.split("=")[1]
      const eventId = typeof crypto.randomUUID === 'function' ? 'ev_' + crypto.randomUUID() : 'ev_' + Date.now() + '_' + Math.random().toString(36).substring(2, 9);

      const downloads = [];
      const singleGuide = form.querySelector('input[name="singleGuide"]');
      if(singleGuide) {
        downloads.push(singleGuide.value)
      } else {
        form.querySelectorAll('input[name="multipleGuides"]:checked').forEach((guide) => {
          downloads.push(guide.value);
        });
      }

      if(downloads.length === 0) {
        guideForm.classList.add('error');
        guideForm.querySelector('.guide-form__error p').innerHTML = 'Please select at least one guide to download.';
        guideForm.querySelector('.guide-form__error').classList.add('active');

        return;
      }

      const data = {
        token: token,
        email: email,
        reactivate_existing: true,
        send_welcome_email: true,
        utm_source: 'arnoldspumpclub.com',
        utm_medium: 'referral',
        utm_campaign: campaign,
        referring_site: 'https://arnoldspumpclub.com',
        event_source_url: window.location.href,
        event_id: eventId,
        fbc: fbc,
        fbp: fbp,
        client_user_agent: navigator.userAgent
      };

      var requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
        redirect: 'follow',
      };

      guideForm.classList.add('loading');

      const result = await fetch(url, requestOptions)
        .then((response) => response.json())
        .then((result) => result)
        .catch((error) => console.log('error', error));

      //console.log('result:', result);

      if(result.data.status === 'active' || result.data.status === 'pending' || result.data.status === 'validating') {
        // Send Meta Pixel event
        if(window.fbq) {
          window.fbq('track', 'Lead', {
            email: email,
          }, eventId)
        }

        guideForm.classList.remove('loading');
        guideForm.classList.add('success');
        guideForm.querySelector('.guide-form__success').classList.add('active');
        guideForm.querySelector('input[type="email"]').value = '';

        downloads.forEach(function(download) {
          if(download.startsWith('//')) {
            download = 'https:' + download;
          }
          const filename = getFilenameFromURL(download);
          saveAs(download, filename);
        });

        setTimeout(function() {
          guideForm.classList.remove('success');
          guideForm.querySelector('.guide-form__success').classList.remove('active');
        }, 10000);

      } else {
        guideForm.classList.remove('loading');
        guideForm.classList.add('error');
        guideForm.querySelector('.guide-form__error p').innerHTML = 'An error has occurred';
        guideForm.querySelector('.guide-form__error').classList.add('active');

        setTimeout(function() {
          guideForm.classList.remove('error');
          guideForm.querySelector('.guide-form__error').classList.remove('active');
        }, 5000);
      }

    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  initGuideForms();
});